import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { AutoSizer, List } from 'react-virtualized';

import { openShipperOrderDetail } from 'redux/modules/shipper-orders/effects';

import TableRow from 'modules/recurring-orders/TableRow';
import TableHeader from 'modules/recurring-orders/TableHeader';
import Loading from 'modules/recurring-orders/Detail/Content/Loading';

import tableCellsConfig from './tableCellsConfig';

import { TableTitle } from './styled';

const t = {
  active_orders: 'Active orders',
};

class ShipperOrderFromRecurringTable extends Component {
  constructor(props) {
    super(props);
    this.rowRenderer = this.rowRenderer.bind(this);
  }

  getRowData = (index) => {
    const { activeOrders } = this.props;

    const item = {
      ...activeOrders[index],
      number_of_real_pallets: activeOrders[index].display_number_of_items,
      type_pallets: activeOrders[index].pallet_type,
      showEquivalents: true,
    };

    return item || {};
  };

  rowRenderer({ index, key, style }) {
    const item = this.getRowData(index);

    return (
      <TableRow
        key={key}
        style={style}
        item={item}
        tableCellsConfig={tableCellsConfig}
        onClick={() => this.props.openShipperOrderDetail({ id: item.id })}
      />
    );
  }

  render() {
    const ORDER_TABLE_ITEM_HEIGHT = 65;
    const { activeOrders, loading } = this.props;

    if (loading) {
      return <Loading />;
    }

    return (
      <div>
        <TableTitle>{t.active_orders}</TableTitle>
        <TableHeader tableCellsConfig={tableCellsConfig} />
        <AutoSizer disableHeight>
          {({ width }) => (
            <List
              {...activeOrders}
              height={activeOrders.length * ORDER_TABLE_ITEM_HEIGHT}
              width={width}
              overscanRowCount={10}
              rowCount={activeOrders.length}
              rowHeight={ORDER_TABLE_ITEM_HEIGHT}
              rowRenderer={this.rowRenderer}
              ref={(ref) => (this.list = ref)}
            />
          )}
        </AutoSizer>
      </div>
    );
  }
}

ShipperOrderFromRecurringTable.propTypes = {
  recurringOrder: PropTypes.shape({}),
  openShipperOrderDetail: PropTypes.func.isRequired,
  activeOrders: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default connect(null, {
  openShipperOrderDetail,
})(ShipperOrderFromRecurringTable);
